module.exports = __webpack_public_path__ + "static/media/cases_3d_02e.aec06f62.jpg";